import {DynamicPageServerSideProps} from '@/_application/core/types';
import SortingFilterToolbar from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter-toolbar';
import {ProductCardListMobile} from '@/_application/modules/products/components/product-card-list.mobile';
import {useProductSortFields, useProductsAggregations} from '@/framework/product';
import {pageNameServerSideAtom} from '@/store/mobile-layout/mobile-layout';
import {useAtom} from 'jotai';
import {useEffect, useMemo} from 'react';
import {Element} from 'react-scroll';
import {BrandInfoCard} from '@/_application/pages/brand/components/brand-info-card';
import {
    getUniqueAggregation,
    getValidAggregationList,
    getValidSortField,
} from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/helper/attributes';
import {SortFields} from '@/__generated__/__types__';

export default function BrandPageMobile({variables}: Readonly<DynamicPageServerSideProps>) {
    const currentPage = variables?.types?.page ?? '';

    const {fetchAggregation, data: aggregations} = useProductsAggregations();
    const {fetchSortFields, data: sortFields} = useProductSortFields();
    const [, setPageNameServerSide] = useAtom(pageNameServerSideAtom);

    useEffect(() => {
        if (!variables?.brand?.label) {
            return;
        }
        const filterBrand = {brand: {eq: variables?.brand?.label}};
        fetchAggregation({filter: filterBrand});
        fetchSortFields({filter: filterBrand});
        setPageNameServerSide(variables?.brand?.label);
        return () => {
            setPageNameServerSide('');
        };
    }, [variables?.brand]);

    if (!variables?.brand?.label) {
        return null;
    }

    const validSortFields: SortFields = useMemo(() => {
        return getValidSortField(sortFields ?? {});
    }, [JSON.stringify(sortFields)]);

    const validAggregationList = useMemo(() => {
        const filterAggregations = aggregations.filter(aggregation => aggregation.attribute_code === 'category_id');
        const uniqueAggregations = getUniqueAggregation(filterAggregations);
        return getValidAggregationList(uniqueAggregations, currentPage);
    }, [currentPage, JSON.stringify(aggregations)]);

    return (
        <div className="bg-secondary pt-16">
            <div className={`active fixed top-16 z-20 shadow-md`}>
                <SortingFilterToolbar
                    currentPage={currentPage}
                    aggregations={validAggregationList}
                    sortFields={validSortFields}
                />
            </div>
            <div className="bg-white">
                <div className="flex w-full items-center justify-center py-4">
                    <BrandInfoCard brand={variables?.brand} />
                </div>
                <div className="mx-auto mt-2 h-1 w-[92vw] border-t border-gray-200 bg-white"></div>
                <Element
                    name="grid"
                    className="flex border-solid border-border-200 border-opacity-70 bg-linear-to-b from-white to-gray-100">
                    <ProductCardListMobile
                        initialProducts={variables?.products?.products}
                        productListItemsQueryOptions={variables.productListItemsQueryOptions}
                    />
                </Element>
            </div>
        </div>
    );
}
